<template>

    <m-edit1/>

    <m-single-chat-1 v-bind='{...{"slug":null,"embedded":false,"defaultCategory":null,"chatUsers":[]},...{}}' :style='""' class="my-5" ></m-single-chat-1>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mSingleChat1 from '@moeinmdn/miw-alpha-components/src/package/Chat/Single/SingleChat1';

export default {
    name: 'HomeView',
    components: {mEdit1, mSingleChat1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
